module.exports = __webpack_public_path__ + "img/lithuania.e74492f4.png";